// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__sm8JJ","clinicsSelect":"TableHeading_clinicsSelect__1WAkG"};